<div class="search-filter-title colored-heading">Site Bookmarks</div>
<div class="bookmarks-container">
  <div class="bookmark-tiles">
    @for (bookmark of bookmarks; track $index) {
      <a
        href="javascript:void(0);"
        class="bookmark-tile"
        (click)="goToBookmark(bookmark)"
      >
        <a
          href="javascript:void(0);"
          class="close-btn"
          title="Delete"
          (click)="deleteBookmark(bookmark.id, $event)"
          >×</a
        >
        <img [src]="bookmark.thumbnail" alt="bookmark thumbnail" />
        <span class="bookmark-name" [title]="bookmark.name">{{
          bookmark.name
        }}</span>
      </a>
    }
  </div>
  <a href="javascript:void(0)" class="add-bookmark" (click)="addBookmark()">
    <i class="fas fa-plus"></i>
    <span>+</span>
  </a>
</div>

@if (showDialog) {
  <div class="dialog-overlay">
    <div class="dialog">
      <h2>Enter Bookmark Name</h2>
      <input
        type="text"
        [(ngModel)]="bookmarkName"
        placeholder="Bookmark name"
      />
      <div class="dialog-actions">
        <button (click)="closeDialog()">Cancel</button>
        <button (click)="saveBookmark()" class="primary">Save</button>
      </div>
    </div>
  </div>
}
